const $ = require('cash-dom');
const GAEvents = require('./ga-events');

const YoutubeEmbedEvents = {
  init() {
    window.addEventListener('blur',function(){
      let activeEl = $(document.activeElement);

      if(activeEl.prop('tagName') === 'IFRAME' && activeEl.attr('src').indexOf('youtube.com/embed') > 0){
        GAEvents.sendEvent('YouTubeEmbedShortcode', 'VideoPlayed', document.title);

        if (typeof aloomaPageData !== 'undefined' && typeof aloomaSendEvent !== 'undefined') {
          let aloomaData = $.extend({}, aloomaPageData);
          aloomaData.eventName = 'YouTubeEmbedShortcode';

          aloomaSendEvent('VideoPlayed', aloomaData);
        }
      }
    });
  }
}

module.exports = YoutubeEmbedEvents;